import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { pickerDriverFactory } from './Picker.driver';
import { Picker } from '.';

const noop = () => {};
const defProps = {
  value: 'October 2020',
};

describe('Picker', () => {
  const createDriver = createRendererWithUniDriver(pickerDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(
      <Picker onPrev={noop} onNext={noop} {...defProps} />,
    );
    expect(await driver.exists()).toBe(true);
  });

  it('should show prev disabled state', async () => {
    const { driver } = createDriver(
      <Picker onPrev={noop} onNext={noop} prevDisabled {...defProps} />,
    );
    expect(await driver.hasDisablePrev()).toBe(true);
  });

  it('should show next disabled state', async () => {
    const { driver } = createDriver(
      <Picker onPrev={noop} onNext={noop} nextDisabled {...defProps} />,
    );
    expect(await driver.hasDisableNext()).toBe(true);
  });

  it('shold click next', async () => {
    const mockOnNext = jest.fn(noop);
    const { driver } = createDriver(
      <Picker onPrev={noop} onNext={mockOnNext} {...defProps} />,
    );
    await driver.clickOnNext();
    expect(mockOnNext).toHaveBeenCalled();
  });

  it('shold click prev', async () => {
    const mockOnPrev = jest.fn(noop);
    const { driver } = createDriver(
      <Picker onPrev={mockOnPrev} onNext={noop} {...defProps} />,
    );
    await driver.clickOnPrev();
    expect(mockOnPrev).toHaveBeenCalled();
  });

  it('shold have next aria label attribute', async () => {
    const nextAriaLabel = 'next';
    const { driver } = createDriver(
      <Picker
        nextAriaLabel={nextAriaLabel}
        onPrev={noop}
        onNext={noop}
        {...defProps}
      />,
    );
    expect(await driver.getNextAriaLabel()).toBe(nextAriaLabel);
  });

  it('shold have prev aria label attribute', async () => {
    const prevAriaLabel = 'prev';
    const { driver } = createDriver(
      <Picker
        prevAriaLabel={prevAriaLabel}
        onPrev={noop}
        onNext={noop}
        {...defProps}
      />,
    );
    expect(await driver.getPrevAriaLabel()).toBe(prevAriaLabel);
  });
});
